import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { Package } from '../package'
import { PackageDetailComponent } from '../package-detail/package-detail.component'

@Component({
  selector: 'app-package-detail-side',
  templateUrl: './package-detail-side.component.html',
  styleUrls: ['./package-detail-side.component.scss'],
  imports: [PackageDetailComponent],
})
export class PackageDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public package: Package
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.package = route.snapshot.data['package']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.shellService.closeSideContent()
  }
}
